export enum DeviceType {
  SIGNING = 'SIGNING',
  TRUSTED = 'TRUSTED',
  UNREGISTERED = 'UNREGISTERED',
}

export interface Device {
  alias: string
  lastConnection: string
  type: DeviceType
  id: string
  daysUntilExpiration: number
  biometricEnabled?: boolean
}

export interface DeviceListParams {
  type?: DeviceType
}

export interface RefreshDevicesParams {
  params: DeviceListParams
  signal?: AbortSignal
}
export interface AddTrustDeviceParams {
  alias?: string
  fid: string
}

export interface DeviceSigningPayload {
  fid: string
  alias?: string
}

export interface DeleteDeviceSigningParams {
  id: string
}

export interface DeleteDeviceTrustedParams {
  id: string
}

export interface RefreshTokenParams {
  fcmToken: string
}

export interface UpdateDeviceAliasParams {
  id: string
  alias: string
}
